<div class="container-tooltip">
    <div
        [matTooltip]="(tooltip.hiddenTooltip ? '' : tooltip.text)"
        [matTooltipPosition]="tooltip.position"
        [matTooltipClass]="'induxtry-tooltip ' + tooltip.position"
      >
        <ng-content></ng-content>
    </div>
</div>
